import { useEffect } from 'react';
import { useIsAuthorized } from '../../features/auth/operations';
import { getRealDate } from '../../helpers/timezone-change-helper';
import { addSeconds, isBefore } from 'date-fns';

const localStorageKey = 'lmpm-login-activity';
const localStorageInterval = 3000;
/*
 * Function saves last time user _was_ logged in (not the time when user enters login/password, but last time before it was logged out)
 */
export function useSaveLastLoggedInTime() {
  const isAuth = useIsAuthorized();
  useEffect(() => {
    if (isAuth !== true) return;

    const timerId = setInterval(setLastLoggedInTime, localStorageInterval);

    return () => {
      clearInterval(timerId);
    };
  }, [isAuth]);
}

function setLastLoggedInTime() {
  window.localStorage.setItem(
    localStorageKey,
    getRealDate().getTime().toString(),
  );
}

export function getLastLoggedInTime(): Date {
  const value = window.localStorage.getItem(localStorageKey) ?? '0';
  return new Date(parseInt(value));
}

export function isLastLoggedInTimeMoreThanNSecondsAgo(n: number): boolean {
  return isBefore(getLastLoggedInTime(), addSeconds(getRealDate(), -n));
}
